const TEXTS_BICIS = {
  es_ES: new Map(
    [
      ['graficaUmbral', 'Vehiculos / hora'],
      ['graficaIntensidadMensual', 'Mayor intensidad mensual'],
      ['graficaIntensidadAnual', 'Mayor intensidad anual'],
    ],
  ),
  ca_ES: new Map([
    ['graficaUmbral', 'Vehicles / hora'],
    ['graficaIntensidadMensual', 'Major intensitat mensual'],
    ['graficaIntensidadAnual', 'Major intensitat anual'],
  ]),
};
export default TEXTS_BICIS;
